'use es6';

const currentEmailDetails = state => state.getIn(['entities', 'emailDetails']).getData();
export default currentEmailDetails;